import React from 'react';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import PaymentPartners from '../containers/PaymentPartners.jsx';
import Payrolls from '../containers/Payrolls.jsx'
import Layout from '../components/Layout.jsx';

const App = (props) => {
    return (
        <BrowserRouter>
          <Layout>
            <Switch>
                <Route exact path="/tesoreria/nominas-pago">
                    <PaymentPartners recruiters={props.recruiters}
                                     clients={props.clients}/>
                </Route>
                <Route exact path="/tesoreria/nominas-creadas">
                    <Payrolls />
                </Route>    
            </Switch>
          </Layout>    
        </BrowserRouter>
    )
};

export default App;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/routes/App.jsx